import { render } from "./DetailBarang.vue?vue&type=template&id=f684427a&scoped=true"
import script from "./DetailBarang.vue?vue&type=script&lang=js"
export * from "./DetailBarang.vue?vue&type=script&lang=js"

import "./DetailBarang.vue?vue&type=style&index=0&id=f684427a&scoped=true&lang=css"
import "./DetailBarang.vue?vue&type=style&index=1&id=f684427a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f684427a"]])

export default __exports__